exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n  height: 100vh;\n  /*background-color: #005B9A;*/\n}\n", ""]);

// exports
